(function () {
  Flint.file('mframework/views/lightbox.js', function (require) {
    Flint.view('Lightbox', function (view, on, $) {
      var pro = initPro(view, {
        picKeys: M.listAtom(),
        isOpen: M.defaultAtom(true),
        selectedIndex: atom(),
        initialSelectedIndex: atom()
      });

      var bodyWidth = atom(document.body.offsetWidth);
      var bodyHeight = atom(document.body.offsetHeight);

      on.resize(window, function (e) {
        bodyWidth.set(document.body.offsetWidth);
        bodyHeight.set(document.body.offsetHeight);
      });

      var isOpen = atom();

      var openCloseReactor = isOpen.reactor(function (isOpen) {
        if (isOpen) {
          view.props.onOpen && view.props.onOpen({});
        } else {
          view.props.onClose && view.props.onClose({});
        }
      }).start();

      pro.isOpen.react(function (propIsOpen) {
        openCloseReactor.stop();
        isOpen.set(propIsOpen);
        openCloseReactor.start();
      });

      var selectedIndex = atom(pro.initialSelectedIndex.get() || 0);
      var selectReactor = selectedIndex.reactor(function (selectedIndex) {
        view.props.onSelect && view.props.onSelect({ selectedIndex: selectedIndex });
      }).start();

      pro.selectedIndex.react(function (propSelectedIndex) {
        if (propSelectedIndex != null) {
          selectReactor.stop();
          selectedIndex.set(propSelectedIndex);
          selectReactor.start();
        }
      });

      on.keydown(window, function (e) {
        if (!view.mounted) {
          // This code path is due to a Flint bug
          return;
        }

        if (e.keyCode == 37) {
          // Left
          selectedIndex.set((selectedIndex.get() + pro.picKeys.get().size - 1) % pro.picKeys.get().size);
        } else if (e.keyCode == 39) {
          // Right
          selectedIndex.set((selectedIndex.get() + 1) % pro.picKeys.get().size);
        }
      });view.render(function () {
        return view.el(
          ['MModal', 1],
          {
            isOpen: isOpen.get(),
            onRequestClose: function () {
              return isOpen.set(false);
            },
            overlayStyle: {
              cursor: 'zoom-out'
            },
            contentStyle: {
              cursor: 'default',
              borderRadius: 8
            }
          },
          Flint.iff(pro.picKeys.get().size >= 2) && view.el(
            ['Carousel', 1],
            { if: pro.picKeys.get().size >= 2,
              selectedIndex: selectedIndex.get(),
              onSelect: function (e) {
                return selectedIndex.set(e.selectedIndex);
              },
              width: .8 * bodyWidth.get(),
              height: .9 * bodyHeight.get(),
              buttonWidth: 60
            },
            Flint.range(pro.picKeys.get()).map(function (_, _index) {
              return view.el(['Pic', 1, _, _index], { repeat: pro.picKeys.get(),
                picKey: _,
                fit: 'clip',
                style: {
                  width: .8 * bodyWidth.get() - 120,
                  height: .9 * bodyHeight.get(),
                  background: '#f6f6f6'
                }
              });
            })
          ),
          Flint.iff(pro.picKeys.get().size == 1) && view.el(['Pic', 2], { if: pro.picKeys.get().size == 1,
            picKey: pro.picKeys.get().get(0),
            fit: 'clip',
            style: {
              maxWidth: .8 * bodyWidth.get(),
              maxHeight: .9 * bodyHeight.get(),
              background: '#f6f6f6',
              cursor: 'zoom-out'
            },
            onClick: function () {
              return isOpen.set(false);
            }
          })
        );
      });
    });
  })
})();
//# sourceMappingURL=lightbox.js.map
